import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useProgressContext } from '../components/ModulePageLayout';

/**
 * Redirige vers le diagnostic initial si la formation l'exige et que l'apprenant
 * ouvre une URL de module (timeline déjà corrigée ; ce hook sécurise les liens directs).
 */
export function useDiagnosticAccessGuard(): void {
  const { diagnosticBlocking } = useProgressContext();
  const { courseId } = useParams<{ courseId: string }>();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!courseId || !diagnosticBlocking) return;
    if (location.pathname.includes('/assessment')) return;
    navigate(`/course/${courseId}/assessment/initial`, { replace: true });
  }, [courseId, diagnosticBlocking, location.pathname, navigate]);
}
